import { z } from 'zod/v4';
import { type SolarDesignDraftState } from './solarDesignDraft';
import { pvWattsSnapshotSchema } from './solarPvWatts';
import { currentSolarWeatherSnapshot } from './solarWeatherGeneration';

/** Financial capture evidence: the weather result the forecast was built from. */
export const solarMonthlySourceProofSchema = z
  .object({
    source: z.literal('pvwatts_v8'),
    weather: pvWattsSnapshotSchema,
  })
  .strict();
export type SolarMonthlySourceProof = z.infer<
  typeof solarMonthlySourceProofSchema
>;
export type SolarMonthlyGenerationForDesign = {
  monthlyAcKwh: number[];
  proof: SolarMonthlySourceProof;
};

/** Only a current PVWatts result supplies monthly generation for new finance. */
export const solarMonthlyGenerationForDesign = (
  state: SolarDesignDraftState
): SolarMonthlyGenerationForDesign | null => {
  const weather = currentSolarWeatherSnapshot(state);
  if (!weather) return null;
  return {
    monthlyAcKwh: [...weather.monthlyAcKwh],
    proof: { source: 'pvwatts_v8', weather },
  };
};

export const solarMonthlySourceForDesign = (
  state: SolarDesignDraftState
): number[] | null =>
  solarMonthlyGenerationForDesign(state)?.monthlyAcKwh ?? null;
